import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import icArrowUp from '../../assets/icons/white-arrow-up.png';
import icArrowDown from '../../assets/icons/white-arrow-down.png';

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex'
    },
    title: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        color: '#ffffff',
        cursor: 'pointer',
        letterSpacing: '0.13px',
        lineHeight: '16.3px'
        // fontFamily: 'UniviaPro'
    },
    icons: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 7,
        cursor: 'pointer'
    },
    icon: {
        width: 9,
        height: 9
    },
    hidden: {
        display: 'none'
    }
}));

/** 
 * title: 'Name'
 * field: 'subject' | 'id' | 'name'...
 * order: { field: 'subject', order: 'ASC' | 'DESC' }
*/
function HeaderSortable({ title, field, order, setOrder, hiddenIconSort }) {
    const classes = useStyles();
    const showUpOpacity = (field + ' ASC' === order.field + ' ' + order.order || field !== order.field) ? 1 : 0;
    const showDownOpacity = (field + ' DESC' === order.field + ' ' + order.order || field !== order.field) ? 1 : 0;

    const onClick = () => {
        if (!hiddenIconSort) {
            if (field + ' DESC' === order.field + ' ' + order.order) {
                setOrder({
                    field,
                    order: 'ASC'
                });
            } else {
                setOrder({
                    field,
                    order: 'DESC'
                });
            }
        }
    }

    return (
        <Box className={classes.container}>
            <Typography className={classes.title} onClick={onClick}>{title}</Typography>
            <Box className={hiddenIconSort ? classes.hidden : classes.icons} onClick={onClick}>
                <img alt='Up arrow' src={icArrowUp} className={classes.icon} style={{ opacity: showUpOpacity }} />
                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: showDownOpacity }} />
            </Box>
        </Box>
    );
}

HeaderSortable.propTypes = {
    title: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
    order: PropTypes.object.isRequired,
    setOrder: PropTypes.func.isRequired,
};

export default HeaderSortable;
